import { NestUpdateTrackingResource, ResourceConfig } from '@hidat/huijs-resource';
import { FieldConfig, ModelInterface, NameableInterface } from '@hidat/huijs-common';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';
import { SplixerResourceTypes } from './splixer-resource-types';

export const ListenerConfig: ResourceConfig = new ResourceConfig(
  SplixerResourceTypes.Listener,
  'listeners',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.uid,
    splixerFieldConfigs.name,
    splixerFieldConfigs.imageUrl,
    new FieldConfig('email'),
  ]);

/**
 * Listener
 * A tenant level listener and profile information
 */
export interface ListenerInterface extends NameableInterface, ModelInterface, NestUpdateTrackingResource {
  email: string | undefined | null;
  externalId: string | undefined | null;
  imageUrl: string | undefined;
}
